import SettingsPartContainer from "./SettingsPartContainer";
import UICreatorComponent from "@baseUI/utils/UICreatorComponent";
import InfoSettingsPartArranger from "@baseUI/component/settings/InfoSettingsPartArranger";
import UIFacade from "@baseUI/UIFacade";

export default class InfoSettingsPartContainerPortrait extends SettingsPartContainer {
  constructor() {
    super()

    this.settings = {
      imageArranger: () => {},
      contentWidth: 1100,
      chaptersGap: 30,
      fieldsGap: 15
    }

    this.settings.imageArranger = (image, chapter) => {
      image.x = this.settings.contentWidth;
      image.y = chapter.height / 2 - image.height / 2;
    }

    this.panelPopup = UICreatorComponent.addScrollableContainer(this, {
      boxWidth: 1300,
      boxHeight: 1200,
      overflowX: "hidden",
      overflowY: "auto"
    })
    this.panelPopup.name = 'InfoSettingsPopupPortrait';
  }

  updateText() {
    new InfoSettingsPartArranger().create(this.data, this.panelPopup, this.settings);
  }

  get data() {
    return UIFacade.InfoChapters;
  }
}
